/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import GroupListItem from './GroupListItem';

const GroupsList = (props) => {
  const {
    groups: pGroups,
    loading,
    selectedGroupId,
    showSelectedMark,
    onSelectGroup,
    onEditGroup,
    onRemoveGroup,
  } = props;

  const groups = loading ? Array.from(new Array(3)) : pGroups;

  return (
    <List>
      {groups.map((group, index) => (
        <GroupListItem
          key={index}
          group={group}
          loading={loading}
          selected={selectedGroupId === group?._id}
          onSelectGroup={onSelectGroup}
          onEditGroup={onEditGroup}
          onRemoveGroup={onRemoveGroup}
          showSelectedMark={showSelectedMark}
          canBeDeleted={groups.length > 1}
        />
      ))}
      {groups.length === 0 && !loading && (
        <ListItem>
          <ListItemText
            primary={<FormattedMessage id="groups.emptyMessage" />}
          />
        </ListItem>
      )}
    </List>
  );
};

GroupsList.propTypes = {
  groups: PropTypes.array,
  loading: PropTypes.bool,
  selectedGroupId: PropTypes.string,
  showSelectedMark: PropTypes.bool,

  onSelectGroup: PropTypes.func,
  onEditGroup: PropTypes.func,
  onRemoveGroup: PropTypes.func,
};

GroupsList.defaultProps = {
  groups: [],
  loading: false,
  selectedGroupId: undefined,
  showSelectedMark: false,

  onSelectGroup() {},
  onEditGroup() {},
  onRemoveGroup() {},
};

export default GroupsList;
